module.exports = __webpack_public_path__ + "static/images/month-banner.de2bbeb.png";